import mandateProvider from '@/apiProviders/mandates/mandate.provider';
import mandateModeConst from '@/consts/mandateMode.const';
import statusConst from '@/consts/status.const.js';
import Vue from 'vue';

const mandateModule = {
  namespaced: true,

  state: {
    mandate: {},
    mandateStatus: statusConst.PENDING,
    mode: mandateModeConst.READ,
  },

  actions: {
    async fetchMandateById({ commit }, mandateId) {
      commit('setMandateStatus', statusConst.LOADING);

      try {
        const mandate = await mandateProvider.getMandate(mandateId);
        commit('setMandate', mandate);
        commit('setMandateStatus', statusConst.SUCCESS);
      } catch (err) {
        commit('setMandateStatus', statusConst.FAIL);
      }
    },

    async editMandate({ state, commit }) {
      commit('setMandateStatus', statusConst.LOADING);

      try {
        await mandateProvider.updateMandate(state.mandate);
        // After updating the mandate, it should set the new mandate info into de state.mandate
        // commit('setMandate', mandate);
        commit('setMandateStatus', statusConst.SUCCESS);
      } catch (err) {
        commit('setMandateStatus', statusConst.FAIL);
        throw new Error('Request failed');
      }
    },
  },

  mutations: {
    setMandate(state, payload) {
      Vue.set(state, 'mandate', payload);
    },
    setMode(state, payload) {
      Vue.set(state, 'mode', payload);
    },
    setMandateStatus(state, payload) {
      Vue.set(state, 'mandateStatus', payload);
    },
  },

  getters: {},
};

export default mandateModule;
